// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + "webfontloader" + "." + "37b1746e" + ".js";
};